/*
 * © 2020 Microsoft. All rights reserved.
 */

define('util/CustomWordWrapper',['lodash', 'absolute/stringmanager'],
    function (_, _s) {

        var addInfoObject = function (char, isNonBeginningChar, isNonEndingChar) {
            return {
                Character: char,
                IsNonBeginningCharacter: isNonBeginningChar,
                IsNonEndingCharacter: isNonEndingChar
            };
        };

        var BreakArray = [
            addInfoObject(0x0021, true, false),    // 0021: !                                         fr, etc.
            addInfoObject(0x0024, false, true),     // 0024: $                                         kr
            addInfoObject(0x0025, true, false),    // 0025: %                                         tc, kr
            addInfoObject(0x0027, true, true),     // 0027: '                                         fr
            addInfoObject(0x0028, false, true),     // 0028: (                                         tc, kr
            addInfoObject(0x0029, true, false),    // 0029: )                                         fr, etc.
            addInfoObject(0x002C, true, false),    // 002C: ,
            addInfoObject(0x002E, true, false),    // 002E: .                                         fr
            addInfoObject(0x002F, true, true),     // 002F: /                                         fr, etc.
            addInfoObject(0x003A, true, false),    // 003A: :                                         tc, kr
            addInfoObject(0x003B, true, false),    // 003B: ;                                         tc, kr
            addInfoObject(0x003F, true, false),    // 003F: ?                                         fr
            addInfoObject(0x005B, false, true),     // 005B: [                                         tc, kr
            addInfoObject(0x005C, false, true),     // 005C: Reverse Solidus                           kr
            addInfoObject(0x005D, true, false),    // 005D: ]                                         tc, kr
            addInfoObject(0x007B, false, true),     // 007B: {                                         tc, kr
            addInfoObject(0x007D, true, false),    // 007D: }                                         tc, kr
            addInfoObject(0x00A2, true, false),    // 00A2: ��  Cent Sign                              etc.
            addInfoObject(0x00A3, false, true),     // 00A3: Pound Sign                                tc
            addInfoObject(0x00A5, false, true),     // 00A5: Yen Sign                                  tc
            addInfoObject(0x00A7, false, true),     // 00A7: Section Sign                              ja
            addInfoObject(0x00A8, true, false),    // 00A8: �N Diaeresis                              etc.
            addInfoObject(0x00A9, true, false),    // 00A9: ccopyright sign                           etc.
            addInfoObject(0x00AE, true, false),    // 00AE: Rregistered sign                          etc.
            addInfoObject(0x00B0, true, false),    // 00B0: Degree Sign                               kr
            addInfoObject(0x00B7, true, true),     // 00B7: Middle Dot                                tc
            addInfoObject(0x02C7, true, false),    // 02C7: ? Caron                                   etc.
            addInfoObject(0x02C9, true, false),    // 02C9: ? Modified Letter marcon                  etc.
            addInfoObject(0x2013, true, false),    // 2013: En Dash                                   tc
            addInfoObject(0x2014, true, false),    // 2014: Em Dash                                   tc
            addInfoObject(0x2015, true, false),    // 2015: �\ Horizon bar                            etc.
            addInfoObject(0x2016, true, false),    // 2016: ? Double vertical line                   etc.
            addInfoObject(0x2018, false, true),     // 2018: Left Single Quotation Mark                tc, kr
            addInfoObject(0x2019, true, false),    // 2019: Right Single Quotation Mark               tc, fr, kr
            addInfoObject(0x201C, false, true),     // 201C: Left Double Quotation Mark                tc, kr
            addInfoObject(0x201D, true, false), // 201D: Right Double Quotation Mark               de, kr
            addInfoObject(0x2022, true, false), // 2022: Bullet
            addInfoObject(0x2025, true, false), // 2025: Two Dot Leader                            tc
            addInfoObject(0x2026, true, false), // 2026: Horizontal Ellpsis                        tc
            addInfoObject(0x2027, true, false), // 2027: Hyphenation Point                         tc
            addInfoObject(0x2032, true, false), // 2032: Prime                                     tc, kr
            addInfoObject(0x2033, true, false), // 2033: Double Prime                              kr
            addInfoObject(0x2035, false, true),  // 2035: Reversed Prime                            tc
            addInfoObject(0x2103, true, false), // 2103: Degree Celsius                            ja, kr
            addInfoObject(0x2122, true, false), // 2122: trade mark sign
            addInfoObject(0x2236, true, false), // 2236: ? tilde operator                          etc.
            addInfoObject(0x2574, true, false), // 2574: Box Drawings Light Left                   tc
            addInfoObject(0x266F, false, true),  // 266F: Music Sharp Sign                          ja
            addInfoObject(0x3001, true, false), // 3001: fullwidth ideographic comma               ja, tc
            addInfoObject(0x3002, true, false), // 3002: fullwidth full stop                       ja, tc
            addInfoObject(0x3003, true, false), // 3003: �VDitto Mark                              etc.
            addInfoObject(0x3005, true, false), // 3005: Ideographic Iteration Mark                ja
            addInfoObject(0x3008, false, true),  // 3008: Left Angle Bracket                        tc, kr
            addInfoObject(0x3009, true, false), // 3009: Right Angle Bracket                       tc, kr
            addInfoObject(0x300A, false, true),  // 300A: Left Double Angle Bracket                 tc, kr
            addInfoObject(0x300B, true, false), // 300B: Right Double Angle Bracket                tc, kr
            addInfoObject(0x300C, false, true),  // 300C: Left Corner Bracket                       ja, tc, kr
            addInfoObject(0x300D, true, false), // 300D: Right Corner Bracket                      ja, tc, kr
            addInfoObject(0x300E, false, true),  // 300E: Left White Corner Bracket                 tc, kr
            addInfoObject(0x300F, true, false), // 300F: Rignt White Corner Bracket                tc, kr
            addInfoObject(0x3010, false, true),  // 3010: Left Black Lenticular Bracket             ja, tc, kr
            addInfoObject(0x3011, true, false), // 3011: right black lenticular bracket            ja, tc, kr
            addInfoObject(0x3012, false, true),  // 3012: Postal Mark                               ja
            addInfoObject(0x3014, false, true),  // 3014: Left Tortoise Shell Bracket               tc, kr
            addInfoObject(0x3015, true, false), // 3015: Right Tortoise Shell Bracket              tc, kr
            addInfoObject(0x3016, false, true), // 3016: Left White Lenticular Bracket                                        etc.
            addInfoObject(0x3017, true, false), // 3017: Right White Lenticular Bracket                                        etc.
            addInfoObject(0x301D, false, true),  // 301D: Reversed Double Prime Quotation Mark      tc
            addInfoObject(0x301E, true, false), // 301E: Double Prime Quotation Mark               tc
            addInfoObject(0x301F, true, false), // 301F: Low Double Prime Quotation Mark           tc
            addInfoObject(0x3041, true, false), // 3041: Hiragana Letter Small A                   ja
            addInfoObject(0x3043, true, false), // 3043: Hiragana Letter Small I                   ja
            addInfoObject(0x3045, true, false), // 3045: Hiragana Letter Small U                   ja
            addInfoObject(0x3047, true, false), // 3047: Hiragana Letter Small E                   ja
            addInfoObject(0x3049, true, false), // 3049: Hiragana Letter Small O                   ja
            addInfoObject(0x3063, true, false), // 3063: Hiragana Letter Small Tu                  ja
            addInfoObject(0x3083, true, false), // 3083: Hiragana Letter Small Ya                  ja
            addInfoObject(0x3085, true, false), // 3085: Hiragana Letter Small Yu                  ja
            addInfoObject(0x3087, true, false), // 3087: Hiragana Letter Small Yo                  ja
            addInfoObject(0x308E, true, false), // 308E: Hiragana Letter Small Wa                  ja
            addInfoObject(0x3099, true, false), // 3099: Combining Katakana-Hiragana Voiced Sound Mark (if necessary)
            addInfoObject(0x309A, true, false), // 309A: Combining Katakana-Hiragana Semi-Voiced Sound Mark (if necessary)
            addInfoObject(0x309B, true, false), // 309B: Katakana-Hiragana Voiced Sound Mark       ja
            addInfoObject(0x309C, true, false), // 309C: Katakana-Hiragana Semi-Voiced Sound Mark  ja
            addInfoObject(0x309D, true, false), // 309D: Hiragana Iteration Mark                   ja
            addInfoObject(0x309E, true, false), // 309E: Hiragana Voiced Iteration Mark            ja
            addInfoObject(0x30A1, true, false), // 30A1: Katakana Letter Small A                   ja
            addInfoObject(0x30A3, true, false), // 30A3: Katakana Letter Small I                   ja
            addInfoObject(0x30A5, true, false), // 30A5: Katakana Letter Small U                   ja
            addInfoObject(0x30A7, true, false), // 30A7: Katakana Letter Small E                   ja
            addInfoObject(0x30A9, true, false), // 30A9: Katakana Letter Small O                   ja
            addInfoObject(0x30C3, true, false), // 30C3: Katakana Letter Small Tu                  ja
            addInfoObject(0x30E3, true, false), // 30E3: Katakana Letter Small Ya                  ja
            addInfoObject(0x30E5, true, false), // 30E5: Katakana Letter Small Yu                  ja
            addInfoObject(0x30E7, true, false), // 30E7: Katakana Letter Small Yo                  ja
            addInfoObject(0x30EE, true, false), // 30EE: Katakana Letter Small Wa                  ja
            addInfoObject(0x30F5, true, false), // 30F5: Katakana Letter Small Ka                  ja
            addInfoObject(0x30F6, true, false), // 30F6: Katakana Letter Small Ke                  ja
            addInfoObject(0x30FB, true, false), // 30FB: katakana middle dot                       ja
            addInfoObject(0x30FC, true, false), // 30FC: Katakana-Hiragana Prolonged Sound Mark    ja
            addInfoObject(0x30FD, true, false), // 30FD: Katakana Iteration Mark                   ja
            addInfoObject(0x30FE, true, false), // 30FE: Katakana Voiced Iteration Mark            ja
            addInfoObject(0xFE30, true, false), // FE30: Presentation Form For Vertical Two Dot Leader
            addInfoObject(0xFE50, true, false), // FE50: Small Comma                               tc
            addInfoObject(0xFE51, true, false), // FE51: Small Ideographic Comma                   tc
            addInfoObject(0xFE52, true, false), // FE52: Small Full Stop                           tc
            addInfoObject(0xFE54, true, false), // FE54: Small Semicolon                           tc
            addInfoObject(0xFE55, true, false), // FE55: Small Colon                               tc
            addInfoObject(0xFE56, true, false), // FE56: Small Question Mark                       tc
            addInfoObject(0xFE57, true, false), // FE57: Small Exclamation Mark                    tc
            addInfoObject(0xFE59, false, true),  // FE59: Small Left Parenthesis                    tc
            addInfoObject(0xFE5A, true, false), // FE5A: Small Right Parenthesis                   tc
            addInfoObject(0xFE5B, false, true),  // FE5B: Small Left Curly Bracket                  tc
            addInfoObject(0xFE5C, true, false), // FE5C: Small Right Curly Bracket                 tc
            addInfoObject(0xFE5D, false, true),  // FE5D: Small Left Tortoise Shell Bracket         tc
            addInfoObject(0xFE5E, true, false), // FE5E: Small Right Tortoise Shell Bracket        tc
            addInfoObject(0xFF01, true, false), // FF01: Fullwidth Exclamation Mark                ja, tc
            addInfoObject(0xFF02, true, false), // FF02: �W Fullwidth quotation mark               etc.
            addInfoObject(0xFF04, false, true),  // FF04: Fullwidth Dollar Sign                     kr
            addInfoObject(0xFF05, true, false), // FF05: Fullwidth Percent Sign                    kr
            addInfoObject(0xFF07, true, false), // FF07: �V Fullwidth Apos                         etc.
            addInfoObject(0xFF08, false, true),  // FF08: Fullwidth Left Parenthesis                ja, tc
            addInfoObject(0xFF09, true, false), // FF09: Fullwidth Right Parenthesis               ja, tc
            addInfoObject(0xFF0C, true, false), // FF0C: Fullwidth Comma                           ja, tc, kr
            addInfoObject(0xFF0E, true, false), // FF0E: Fullwidth Full Stop                       ja, tc, kr
            addInfoObject(0xFF1A, true, false), // FF1A: Fullwidth Colon                           ja, tc, kr
            addInfoObject(0xFF1B, true, false), // FF1B: Fullwidth Semicolon                       ja, tc, kr
            addInfoObject(0xFF1F, true, false), // FF1F: Fullwidth Quation Mark                    ja, tc
            addInfoObject(0xFF20, false, true),  // FF20: Fullwidth Commercial At                   ja
            addInfoObject(0xFF3B, false, true),  // FF3B: Fullwidth Left Square Bracket             kr
            addInfoObject(0xFF3D, true, false), // FF3D: Fullwidth Right Square Bracket            kr
            addInfoObject(0xFF40, true, false), // FF40: �M Fullwidth Grave accent                 etc.
            addInfoObject(0xFF5B, false, true),  // FF5B: Fullwidth Left Curly Bracket              ja, tc
            addInfoObject(0xFF5C, true, false), // FF5C: �b Fullwidth Vertical line                etc.
            addInfoObject(0xFF5D, true, false), // FF5D: Fullwidth Right Curly Bracket             kr
            addInfoObject(0xFF5E, true, false), // FF5E: �` Fullwidth Tilda                        etc.
            addInfoObject(0xFF61, true, false), // FF61: Halfwidth Ideographic Full Stop etc.
            addInfoObject(0xFF64, true, false), // FF64: Halfwidth Ideographic Comma etc.
            addInfoObject(0xFF70, true, false), // FF70: Halfwidth Katakana-Hiragana Prolonged Sound Mark etc.
            addInfoObject(0xFF9E, true, false), // FF9E: Halfwidth Katakana Voiced Sound Mark etc.
            addInfoObject(0xFF9F, true, false), // FF9F: Halfwidth Katakana Semi-Voiced Sound Mark etc.
            addInfoObject(0xFFE0, true, true),  // FFE0: Fullwidth Cent Sign                       ja, kr
            addInfoObject(0xFFE1, false, true),  // FFE1: Fullwidth Pound Sign                      fr, kr
            addInfoObject(0xFFE5, false, true),  // FFE5: Fullwidth Yen Sign                        ja
            addInfoObject(0xFFE6, false, true)   // FFE6: Fullwidth Won Sign                        kr
        ];

        var prohibition = true;
        var nohangul = true;

        var isNonBeginningChar = function (c) {
            if (!prohibition) {
                return false;
            }
            var iLeft = 0, iRight = BreakArray.length, iMid = 0;
            while (iLeft <= iRight) {
                iMid = ((iRight - iLeft) / 2) + iLeft;
                iMid = Math.round(iMid);
                if (BreakArray[iMid].Character === c.charCodeAt(0)) {
                    return BreakArray[iMid].IsNonBeginningCharacter;
                }
                if (c.charCodeAt(0) < BreakArray[iMid].Character) {
                    iRight = iMid - 1;
                } else {
                    iLeft = iMid + 1;
                }
            }
            return false;
        };

        var isNonEndingChar = function (c) {
            if (!prohibition) {
                return false;
            }
            var iLeft = 0, iRight = BreakArray.Length, iMid = 0;
            while (iLeft <= iRight) {
                iMid = ((iRight - iLeft) / 2) + iLeft;
                iMid = Math.round(iMid);
                if (BreakArray[iMid].Character === c.charCodeAt(0)) {
                    return BreakArray[iMid].IsNonEndingCharacter;
                }
                if (c < BreakArray[iMid].Character) {
                    iRight = iMid - 1;
                } else {
                    iLeft = iMid + 1;
                }
            }
            return false;
        };

        var isEastAsianChar = function (c) {
            var char = c.charCodeAt(0);
            if (nohangul) {
                if (
                    (0x1100 <= char) && (char <= 0x11FF) ||   // Hangul Jamo
                    (0x3130 <= char) && (char <= 0x318F) ||   // Hangul Compatibility Jamo
                    (0xAC00 <= char) && (char <= 0xD7A3)      // Hangul Syllables
                ) {
                    return false;
                }
            }
            return (
                (0x1100 <= char) && (char <= 0x11FF) ||		// Hangul Jamo
                (0x3000 <= char) && (char <= 0xD7AF) ||		// CJK symbols - Hangul Syllables
                (0xF900 <= char) && (char <= 0xFAFF) ||		// CJK compat
                (0xFF00 <= char) && (char <= 0xFFDC)			// Halfwidth / Fullwidth
            );
        };

        var isWhiteSpace = function (c) {
            var char = c.charCodeAt(0);
            // TODO: Switch to Char.IsWhiteSpace(c)?
            return (c === '\t' ||
                c === '\r' ||
                c === ' ' ||
                char === 0x3000);
        };

        var canBreakLineAt = function (pszStart, index) {
            if (!pszStart[index] || !pszStart[index - 2] || !pszStart[index - 1] || !pszStart[index + 1]) return;;
            if (index === 0) {
                return false;	// leave at least one character in a line
            }
            if (isWhiteSpace(pszStart[index]) && isNonBeginningChar(pszStart[index + 1])) {
                return false;
            }
            if (index > 1) {
                // Do not word wrap when current character is IsEastAsianChar , the previus character as " and before it was space.
                if (isWhiteSpace(pszStart[index - 2]) && pszStart[index - 1] === '\"' && !isWhiteSpace(pszStart[index])) {
                    // Do not leave " at end of line when the leading character is not space.
                    return false;
                }
            }
            // Do not put " at top of line when the " is closing word and leading space.
            if (!isWhiteSpace(pszStart[index - 1]) && pszStart[index] === '\"' && isWhiteSpace(pszStart[index + 1])) {
                return false;
            }
            return ((isWhiteSpace(pszStart[index]) ||
                isEastAsianChar(pszStart[index]) ||
                isEastAsianChar(pszStart[index - 1]) ||
                pszStart[index - 1] === '-') &&
                !isNonBeginningChar(pszStart[index]) &&
                !isNonEndingChar(pszStart[index - 1]));
        };

        var doTextCustomWrap = function (label, size, type, width, height) {
            if (_s.doesUserLanguageSupportWordWrap()) return;
            if (!label || !label.style || !label.text) return;
            if (size <= 1) return;
            if ((label.width <= width) && (label.height <= height)) return;
            var text = label.text, originalText = label.text, hasBroken;
            if (label.parent) {
                if (label.style.wordWrap) {
                    label.style.wordWrap = false;
                    label.updateText();
                }
                label.updateTransform();
                if ((label.width > width) || (label.height > height)) {
                    var brokenLines = [];
                    while (text) {
                        hasBroken = false;
                        label.setText(text);
                        label.updateTransform();
                        if (label.width <= width) {
                            brokenLines.push(text);
                            break;
                        }
                        for (var i = (text.length - 1); i >= 0; i--) {
                            var subString = text.substring(0, i + 1);
                            label.setText(subString);
                            label.updateTransform();
                            if ((label.width <= width) && canBreakLineAt(text, i)) {
                                brokenLines.push(subString);
                                hasBroken = true;
                                text = text.slice(i + 1);
                                break;
                            }
                        }
                        if (!hasBroken) {
                            brokenLines.push(text);
                            break;
                        }
                    }
                    if (brokenLines.length) {
                        label.setText(brokenLines.join('\n'));
                        label.updateTransform();
                    }
                    if ((label.width > width) || (label.height > height)) {
                        label.setText(originalText);
                        size -= 1;
                        label.style.font = [type, ' ', size, 'px Arial'].join('');
                        label.updateText();
                        this.doTextCustomWrap(label, size, type, width, height);
                    }
                }
            } else {
                _s.shrinkToFit(label, size, type, width, height);
            }
        };

        return {
            doTextCustomWrap: doTextCustomWrap
        };
    });

